import React from 'react';

interface MissingPermissionProps {
  entity: string;
  srcImage: string;
  children?: React.ReactNode;
}

export const MissingPermission = ({
  entity,
  srcImage,
  children,
}: MissingPermissionProps) => {
  return (
    <div className="flex flex-col w-full h-full justify-center items-center self-center mb-[40%]">
      <img
        className="max-h-96 w-[60%]"
        src={srcImage}
        alt="MissingPermission"
      />
      <div className="flex flex-col items-center justify-center my-4 space-y-2 w-[60%]">
        <div className="text-sm text-muted-foreground text-center">{`You have no permission to ${entity} at this moment`}</div>
      </div>
      <div className={'flex w-[60%] justify-center items-center'}>
        {children}
      </div>
    </div>
  );
};
